import type { Lang } from "../i18n";
import type { ClauseTableData, TableCell } from "../types";

function cellText(c: TableCell, lang: Lang): string {
  if (typeof c === "string") return c;
  const v = lang === "ru" ? c.ru : lang === "ps" ? c.ps : lang === "fa" ? c.fa : c.en;
  return v || c.en || c.ru || "";
}

export default function ClauseTable({ table, lang }: { table: ClauseTableData; lang: Lang }) {
  const headers = table.headers || [];
  const rows = table.rows || [];
  return (
    <div className="table-scroll">
      <table className="data-table">
        {headers.length > 0 && (
          <thead>
            <tr>
              {headers.map((h, i) => (
                <th key={i}>{cellText(h, lang)}</th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {rows.map((r, ri) => (
            <tr key={ri}>
              {r.map((c, ci) => (
                <td key={ci}>{cellText(c, lang)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
